import { ArrowDown, Check, CircleDashed, RotateCcw } from "lucide-react";

const steps = [
  ["01", "Decompose", "Turn inherited narrative into atomic, falsifiable propositions."],
  ["02", "Retrieve", "Collect every early witness, passage, chain, variant, and modern assessment."],
  ["03", "Challenge", "Send each claim through an adversarial source and dependence audit."],
  ["04", "Reconcile", "Preserve contradictions; distinguish convergence from repeated dependence."],
  ["05", "Rescore", "Update the confidence profile and store the written rationale."],
  ["06", "Publish", "Expose provenance through the graph and return unknown when evidence cannot decide."],
] as const;

export function ResearchLoop() {
  return (
    <section className="loop-section" id="research-loop">
      <div className="loop-copy">
        <h2>A graph designed to become less wrong.</h2>
        <p>Every cycle begins with an attack on the current map. New sources can split a claim, expose dependence, lower confidence, or make an unknown answerable. Nothing is promoted merely because it is familiar.</p>
        <div className="loop-status"><RotateCcw size={18} /><span>Karpathy-like research loops</span><b>Designed</b></div>
      </div>
      <div className="loop-steps">
        {steps.map(([number, title, copy], index) => (
          <div className="loop-step" key={title}>
            <span className="loop-number">{number}</span>
            <div><h3>{title}</h3><p>{copy}</p></div>
            {index < steps.length - 1 ? <ArrowDown size={18} /> : <Check size={18} />}
          </div>
        ))}
      </div>
      <div className="loop-principle"><CircleDashed size={22} /><p><b>Stopping rule</b> The system never forces a synthesis. If the evidence cannot discriminate, the answer remains unknown—with the reason visible.</p></div>
    </section>
  );
}
